// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

// Local Imports
import endPoints from '../../constant';
import axiosInstance from '../../http';

export interface InitialStateProps {
  allServices?: any;
  loading?: boolean;
  error?: string | null;
  addServiceLoading?: any;
  deleteServiceLoading?: any;
}

type AddNewServiveProps = {
  name: string;
  description: string;
  status: boolean;
  duration?: number;
  price?: number;
};
type EditServiveProps = {
  name: string;
  description: string;
  status: boolean;
  duration?: number;
  price?: number;
  id: string;
};

const initialState: InitialStateProps = {
  allServices: [],
  loading: false,
  error: null,
  addServiceLoading: false,
  deleteServiceLoading: false,
};

// All Services API Calling
export const allServicesAPI = createAsyncThunk(
  'dashboard/services',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(endPoints.allServicesListing);
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Create New Service
export const creatNewServiceAPI = createAsyncThunk(
  'dashboard/newService',
  async (values: AddNewServiveProps, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(endPoints.allServicesListing, {
        ...values,
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Create New Service
export const updateServiceAPI = createAsyncThunk(
  'dashboard/updateService',
  async (values: EditServiveProps, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(
        endPoints.allServicesListing + `/${values.id}`,
        {
          ...values,
        }
      );
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Create New Service
export const deleteServiceAPI = createAsyncThunk(
  'dashboard/delete',
  async (values: { id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.delete(
        endPoints.allServicesListing + `/${values.id}`
      );
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Services Slice
export const servicesSlice = createSlice({
  name: 'dashboard/services',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(allServicesAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(allServicesAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.allServices = action.payload;
        state.error = null;
      })
      .addCase(allServicesAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(PURGE, (state) => {
        state.allServices = [];
      })
      .addCase(creatNewServiceAPI.pending, (state, action) => {
        state.addServiceLoading = true;
        state.error = null;
      })
      .addCase(creatNewServiceAPI.fulfilled, (state, action) => {
        state.addServiceLoading = false;
        state.error = null;
      })
      .addCase(creatNewServiceAPI.rejected, (state, action) => {
        state.addServiceLoading = false;
        state.error = action.payload as string;
      })
      .addCase(deleteServiceAPI.pending, (state, action) => {
        state.deleteServiceLoading = true;
        state.error = null;
      })
      .addCase(deleteServiceAPI.fulfilled, (state, action) => {
        state.deleteServiceLoading = false;
        state.error = null;
      })
      .addCase(deleteServiceAPI.rejected, (state, action) => {
        state.deleteServiceLoading = false;
        state.error = action.payload as string;
      })
      .addCase(updateServiceAPI.pending, (state, action) => {
        state.addServiceLoading = true;
        state.error = null;
      })
      .addCase(updateServiceAPI.fulfilled, (state, action) => {
        state.addServiceLoading = false;
        state.error = null;
      })
      .addCase(updateServiceAPI.rejected, (state, action) => {
        state.addServiceLoading = false;
        state.error = action.payload as string;
      });
  },
});

// Action creators are generated for each case reducer function
// export const {  } = servicesSlice.actions;

export default servicesSlice.reducer;
